var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext } from 'react';
import { Typography } from '@mui/material';
import { mergeObjects } from '../helpers';
import { GeebeeComponentsContext } from './geebee/ComponentsWrapper';
var EditableInputWrapperV2 = function (props) {
    var _a, _b;
    var contextEditableProps = useContext(GeebeeComponentsContext);
    var _c = mergeObjects(props, (_a = contextEditableProps === null || contextEditableProps === void 0 ? void 0 : contextEditableProps.editableWrapperProps) !== null && _a !== void 0 ? _a : {}), _d = _c.editable, editable = _d === void 0 ? true : _d, children = _c.children, value = _c.value, typographyProps = _c.typographyProps;
    if (editable)
        return React.createElement(React.Fragment, null, children);
    if (typeof value === 'string' || typeof value === 'number') {
        return (React.createElement(Typography, __assign({ variant: "subtitle2" }, typographyProps, { className: "lfc-truncate ".concat((_b = typographyProps === null || typographyProps === void 0 ? void 0 : typographyProps.className) !== null && _b !== void 0 ? _b : ''), title: String(value) }), value));
    }
    return React.createElement(React.Fragment, null, value);
};
export default EditableInputWrapperV2;
//# sourceMappingURL=EditableInputWrapperV2.js.map